export var MINDBODY = 'MINDBODYAPI';